export const DOWNTIME_ANALYTICS_WIDGET_NAMESPACE = 'widget.downtime-analytics'
